import { isAxiosError } from "axios";

export type AccessProblem = "unauthenticated" | "forbidden" | "error";

/** Map a failed `GET /api/me` to what the shell should show. */
export const accessProblemFromError = (error: unknown): AccessProblem => {
  if (isAxiosError(error)) {
    if (error.response?.status === 401) return "unauthenticated";
    if (error.response?.status === 403) return "forbidden";
  }
  return "error";
};
